import { ID } from '@models/base'
import { PatientVisitModel } from '@models/patientVisit'

type QueueNumberModel = {
  id: ID
  name: string | null
  number: string
  patient_visit: PatientVisitModel
  priority?: QueueNumberPriorityEnum
  type: QueueNumberTypeEnum
  started_at: string
  ended_at?: string
  created_at?: string
  updated_at?: string
}

enum QueueNumberPriorityEnum {
  Red = 'RED',
  Yellow = 'YELLOW',
  Green = 'GREEN',
}

enum QueueNumberTypeEnum {
  Normal = 'NORMAL',
  Appointment = 'APPOINTMENT',
}

export { QueueNumberPriorityEnum, QueueNumberTypeEnum }

export type { QueueNumberModel }
